import React from 'react';
import { Link } from 'react-router-dom';
import { FiGithub, FiTwitter, FiInstagram } from 'react-icons/fi';
import { motion } from 'framer-motion';

const Footer = () => (
  <footer className="mt-20 border-t" style={{ borderColor: 'var(--border)' }}>
    <div className="max-w-screen-xl mx-auto px-6 md:px-12 py-12">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: 'var(--red)' }}>
              <span className="font-display text-white text-xs">M</span>
            </div>
            <span className="font-display text-xl tracking-widest" style={{ color: 'var(--text)' }}>CINESPUR</span>
          </div>
          <p className="text-xs font-body max-w-xs" style={{ color: 'var(--muted)' }}>
            Premium movie streaming experience powered by TMDB. Not affiliated with any streaming service.
          </p>
        </div>
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-6">
            {[['Home', '/'], ['Movies', '/movies'], ['Watchlist', '/watchlist']].map(([label, path]) => (
              <Link key={path} to={path}>
                <span className="text-xs font-body hover:text-white transition-colors" style={{ color: 'var(--muted)' }}>{label}</span>
              </Link>
            ))}
          </div>
          <div className="flex items-center gap-4">
            {[FiGithub, FiTwitter, FiInstagram].map((Icon, i) => (
              <motion.a key={i} href="#" whileHover={{ scale: 1.2, color: '#E50914' }}
                className="transition-colors" style={{ color: 'var(--muted)' }}>
                <Icon size={16} />
              </motion.a>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-8 pt-6 border-t flex items-center justify-between" style={{ borderColor: 'var(--border)' }}>
        <p className="text-xs font-accent" style={{ color: 'var(--muted)' }}>
          © 2025 CINESPUR. All rights reserved.
        </p>
        <p className="text-xs font-accent" style={{ color: 'var(--muted)' }}>
          Data from <span style={{ color: 'var(--red)' }}>TMDB</span>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
